import { Header, headerConfigDefaults } from '@qga/components';
import { createEventCreator } from 'lib/gaTracking/ga';
import useQffUser from 'hooks/useQffUser';
import { FC } from 'react';
import { RELATIONSHIP_BASE_URL } from 'config/env';
import Cookies from 'universal-cookie';
import { useLocation } from 'react-router';

export const RELATIONSHIP_REDIRECT_COOKIE_NAME = 'relationship_redirect_to';
export const COOKIE_PATH = process.env.NODE_ENV === 'development' ? '/' : '/hotels/manage';

const handleInteraction = createEventCreator((info: { type: string; value: string }) => ({ action: info.value, category: info.type }));

const GlobalHeader: FC = () => {
  const { qffUser } = useQffUser();
  const { pathname } = useLocation();

  const handleClickLogin = () => {
    const cookies = new Cookies();
    cookies.set(RELATIONSHIP_REDIRECT_COOKIE_NAME, `${RELATIONSHIP_BASE_URL}${pathname}`, { path: COOKIE_PATH });
    window.location.href = `${RELATIONSHIP_BASE_URL}/login`;
  };

  const handleClickLogout = () => {
    window.location.href = `${RELATIONSHIP_BASE_URL}/logout`;
  };

  return (
    <Header
      {...headerConfigDefaults}
      qffAuthData={{
        memberId: qffUser?.memberId ?? undefined,
        title: qffUser?.title ?? undefined,
        firstName: qffUser?.firstName ?? undefined,
        lastName: qffUser?.lastName ?? undefined,
        membershipTier: qffUser?.membershipTier ?? undefined,
        isAuthenticated: !!qffUser?.memberId,
        pointsBalance: qffUser?.pointsBalance ?? undefined,
      }}
      onClickLogin={handleClickLogin}
      onClickLogout={handleClickLogout}
      onInteraction={handleInteraction}
    />
  );
};

export default GlobalHeader;
